import styled from 'styled-components'

export const QualityLabelComponent = styled.div`
  margin-bottom: 20px;
  position: relative;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    margin-bottom: 30px;
  }

  .quatro-image {
    width: 100%;
    max-width: 60px;
    margin-right: 20px;
  }

  .quality-tooltip {
    margin-left: 10px;
  }

  .item-container {
    display: flex;
    align-items: flex-start;

    &:not(:last-child) {
      margin-bottom: 20px;
    }

    p {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`
